import type { Redaction, RedactionType } from "./types";

export const MIN_REDACTION_PCT = 1;

export const clamp = (v: number, lo: number, hi: number) => Math.min(hi, Math.max(lo, v));
export const round = (v: number) => Math.round(v * 100) / 100;

export function clampRedaction(r: Redaction): Redaction {
  const w = round(clamp(r.w, MIN_REDACTION_PCT, 100));
  const h = round(clamp(r.h, MIN_REDACTION_PCT, 100));
  const x = round(clamp(r.x, 0, 100 - w));
  const y = round(clamp(r.y, 0, 100 - h));
  return {
    ...r,
    type: r.type === "blackout" ? "blackout" : "blur",
    x,
    y,
    w,
    h,
  };
}

export function sanitizeRedactions(items: unknown): Redaction[] {
  if (!Array.isArray(items)) return [];
  const results: Redaction[] = [];
  for (const item of items) {
    if (!item || typeof item !== "object") continue;
    const { id, type, x, y, w, h } = item as Record<string, unknown>;
    if (typeof x !== "number" || typeof y !== "number" || typeof w !== "number" || typeof h !== "number") continue;
    const redId = typeof id === "string" && id ? id : Math.random().toString(36).slice(2, 10);
    const redType: RedactionType = type === "blackout" ? "blackout" : "blur";
    results.push(clampRedaction({
      id: redId,
      type: redType,
      x,
      y,
      w,
      h,
    }));
  }
  return results;
}
